import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalTechnologyNonComplianceModel } from './types';
import { legalTechnologyNonComplianceItemValidator } from './validators/item';

const legalTechnologyNonComplianceValidator: ValidateJSModel<LegalTechnologyNonComplianceModel> = {
  HasNonCompliance: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasNonCompliance && attributes?.HasNonCompliance.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyNonComplianceItemValidator },
      };
    }
    return {};
  },
};
export default legalTechnologyNonComplianceValidator;
